"use client";

import { Box } from "@mui/material";
import { MainAppLayoutTitle, useMainAppLayout } from "@osn/react-components";
import { ReactNode } from "react";

type AppTitleProps = {
  mobileTitle?: ReactNode;
};

export default function AppTitle({ mobileTitle }: AppTitleProps) {
  const { tenantData } = useMainAppLayout();

  if (!mobileTitle) {
    return <MainAppLayoutTitle title={tenantData?.name || "-"} />;
  }

  return (
    <>
      <Box data-cy="mobile-app-title" sx={{ display: { mobile: "contents", laptop: "none" } }}>
        <MainAppLayoutTitle title={mobileTitle} />
      </Box>
      <Box sx={{ display: { mobile: "none", laptop: "contents" } }}>
        <MainAppLayoutTitle title={tenantData?.name || "-"} />
      </Box>
    </>
  );
}
